import { render, staticRenderFns } from "./AnagraficaDetail.vue?vue&type=template&id=cad112c6&"
import script from "./AnagraficaDetail.vue?vue&type=script&lang=ts&"
export * from "./AnagraficaDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports